import { render, staticRenderFns } from "./main.vue?vue&type=template&id=1d180d8c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=1d180d8c&prod&scoped=true&lang=less"
import style1 from "./main.vue?vue&type=style&index=1&id=1d180d8c&prod&lang=css"
import style2 from "./main.vue?vue&type=style&index=2&id=1d180d8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d180d8c",
  null
  
)

export default component.exports